import { IPackageCard } from '@raskrask-dk/rr-components/lib/Organisms/PackageModal/props'
import { PackageBF } from '../../models'
import { PackageCard } from '../../types/interfaceextension'
import { PackageTemplate, Partner } from '@raskrask-dk/raskrask-utils'


export const constructConcretepackages = (
  templates: PackageTemplate[],
  partners: Partner[]
): PackageCard[] => {
  const results: PackageCard[] = []
  let index = 0
  partners.forEach((partner) => {
    templates.forEach((template) => {
      const serviceId = template.service.id;
      const partnerProvidesService = partner.servicetypes.some((s) => s.id === serviceId);
      if (partnerProvidesService) {

        const packageBF = PackageBF.fromPackageTemplate(template, partner)
        const { priceFrom, saveMin } = packageBF.getSaveMinAndFromPrice

        results.push({
          combinationId: index,
          template: template,
          price: priceFrom,
          save: saveMin,
          partner: partner,
        })
        index++
      }
    })
  })
  return results
}

export const getCheapestPackagesPerTemplateAndPackage = (
  packageCards: PackageCard[]
): PackageCard[] => {
  return Array.from(
    packageCards
      .reduce((prev: Map<string, PackageCard>, cur: PackageCard) => {
        const previousPackage = prev.get(
          `${cur.template.multiplier}_${cur.template.service.name}`
        )
        if (previousPackage === undefined) {
          prev.set(
            `${cur.template.multiplier}_${cur.template.service.name}`,
            cur
          )
          return prev
        }
        const isCurrentCheaper = previousPackage.price > cur.price
        if (isCurrentCheaper)
          prev.set(
            `${cur.template.multiplier}_${cur.template.service.name}`,
            cur
          )
        return prev
      }, new Map() as Map<string, PackageCard>)
      .values()
  )
}

export const mapPackageCardInterfaceToPackageModal = (
  packageC: PackageCard,
  inspectedPackage: PackageCard,
  setInspectedPackage: (t: PackageCard) => void,
  icon: string,
  priceLabel: string,
  saveLabel: string,
  serviceNameTranslated: string
): IPackageCard => {
  return {
    buttonName: `${packageC.template.multiplier}x${packageC.template.service.duration.toMillis() / 60 / 1000
      }min`,
    multiplier: packageC.template.multiplier,
    price: {
      label: priceLabel,
      value: packageC.price,
    },
    save: {
      label: saveLabel,
      value: packageC.save,
    },
    service: {
      durationMin:
        packageC.template.service.duration.toMillis() / 60 / 1000,
      icon: icon,
      name: serviceNameTranslated,
    },
    onClickPackageOption: () => {
      setInspectedPackage(packageC)
    },
    isActive: inspectedPackage.template.id === packageC.template.id,
  }
}
